import { Banner } from '@release/ui/Banner';
import { Button } from '@release/ui/Button';
import Link from 'next/link';
import { Typography } from '@release/ui/Typography';

import { useHomeGreeting } from '../hooks/useHomeGreeting';
import { useHomeActions } from '../hooks/useHomeActions';

import { HomeGreeting } from './HomeGreeting';

export const Home: React.FC = () => {
  const greeting = useHomeGreeting();
  const actions = useHomeActions();

  return (
    <div className="flex flex-col gap-y-8 p-4 sp:p-10">
      <HomeGreeting greeting={greeting} />
      <Banner
        severity="info"
        label={
          <Typography size="rat" className="text-sem-l-text-accent">
            このホーム画面はこれから育てていきます。担当案件・お客様のログイン状況・お知らせ・KPIの進捗をここに集める予定です。「こんな情報が朝いちで見たい」があれば
            {/* Intercom は intercom-custom-launcher クラスのクリックで起動する。
                role/tabIndex でフォーカスは受け取れるので、Enter / Space でも同じクリックを発火させる。 */}
            <span
              className="intercom-custom-launcher underline"
              tabIndex={0}
              role="button"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  e.currentTarget.click();
                }
              }}
            >
              こちら
            </span>
            から教えてください。
          </Typography>
        }
      />
      <ul className="flex flex-row gap-4 flex-wrap px-4 sp:px-0">
        {actions.map((action) => (
          <li key={action.label}>
            <Link href={action.href}>
              <Button as="span" label={action.label} variant="secondary" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
